export default "__VITE_ASSET__997b75c1__"